import { FakeIntersectionObserver } from "../FakeIntersectionObserver";
//Todo to be extract on lib - https://jira.dkcorpit.com/browse/SB-24657
export function getIntersectionObserverConstructor() {
    return typeof IntersectionObserver !== "undefined" ?
        IntersectionObserver :
        FakeIntersectionObserver;
}
//# sourceMappingURL=GetIntersectionObserverConstructor.js.map